import { render, staticRenderFns } from "./ReportPeripheralRelate.vue?vue&type=template&id=c6861604"
import script from "./ReportPeripheralRelate.vue?vue&type=script&lang=js"
export * from "./ReportPeripheralRelate.vue?vue&type=script&lang=js"
import style0 from "./ReportPeripheralRelate.vue?vue&type=style&index=0&id=c6861604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports